import React, { useMemo } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { getAvatarBackgroundColor, getAvatarInitials } from '../../utils/avatar.utils';

type IdentityIconProps = {
  input: string;
  size: number;
};

const useStyle = makeStyles(() => ({
  avatar: (props: IdentityIconProps & { backgroundColor?: string }) => ({
    width: props.size,
    height: props.size,
    fontSize: `${Math.round(props.size / 2)}px`,
    backgroundColor: props.backgroundColor,
    color: 'white',
  }),
}));

const useAvatarBackgroundColor = (input: string): string =>
  useMemo(() => getAvatarBackgroundColor(input), [input]);

export const IdentityIcon: React.FC<IdentityIconProps> = (props) => {
  const backgroundColor = useAvatarBackgroundColor(props.input);
  const classes = useStyle({ ...props, backgroundColor });

  return <Avatar className={classes.avatar}>{getAvatarInitials(props.input)}</Avatar>;
};
